import Tag from '@/vdp/Tags/Tag';
import SubSections from '~/constants/subSections';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useGetKBBPromoAmount from '~/hooks/vdp/selectors/useGetKBBPromoAmount';
import CarvanaCircleIcon from '~/icons/CarvanaCircle';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import {
  Card,
  CarvnaPill,
  KBBPill,
  MiddleWrapper,
  PillWrapper
} from './AboutThePrice.styles';

export default function GreatDeal() {
  const kbbPromoAmount = useGetKBBPromoAmount();
  const { price = 0 } = useGetVehicleDetails();
  const kbbPrice = price + kbbPromoAmount;

  const SavingsText = (
    <div className="text-grey-5 tl-body-s m:tl-body-m">
      This vehicle is priced{' '}
      <span className="font-bold text-blue-4">
        ${formatAndDropDecimal(kbbPromoAmount)}
      </span>{' '}
      lower than the Kelley Blue Book® Typical Listing Price.
    </div>
  );

  return (
    <Card id={SubSections.GreatDeal}>
      <Tag text="Great Deal" bigTag bgColor="bg-blue-4" />
      <MiddleWrapper>
        {SavingsText}
        <PillWrapper>
          <KBBPill>
            <span>Kelley Blue Book®</span>
            <span>${formatAndDropDecimal(kbbPrice)}</span>
          </KBBPill>
          <CarvnaPill>
            <div className="flex items-center">
              <span className="mr-8">Carvana</span>
              <CarvanaCircleIcon />
            </div>
            <span>${formatAndDropDecimal(price)}</span>
          </CarvnaPill>
        </PillWrapper>
      </MiddleWrapper>
      <div className="text-grey-5 tl-body-xs">
        Savings amount based on the difference between Kelley Blue Book®
        Typical Listing Price and current Carvana listing price, not including
        tax, title, registration, or delivery costs. Savings amounts are updated
        daily.
      </div>
    </Card>
  );
}
